import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { PlanDocumentUtils, PlannedTier, WorkoutType } from 'fitforce-document-sync';
import { cloneDeep } from 'lodash';

@Component({
  selector: 'document-tier-stairs',
  templateUrl: './document-tier-stairs.component.html',
  styleUrls: ['./document-tier-stairs.component.scss'],
})
export class DocumentTierStairsComponent implements OnChanges {
  selectedUUID: string;

  @Input() readonly canEdit: boolean;
  @Input() readonly tierTemplate: boolean;
  @Input() tiers: PlannedTier[];
  @Input() readonly workoutType?: WorkoutType;
  @Input() readonly selectedTier?: PlannedTier;
  @Input() readonly canMoveTiers: boolean;

  @Output() tierSelected: EventEmitter<PlannedTier> = new EventEmitter<PlannedTier>();
  @Output() tiersUpdated: EventEmitter<PlannedTier[]> = new EventEmitter<PlannedTier[]>();
  @Output() addedTierFromLibrary: EventEmitter<PlannedTier[]> = new EventEmitter<PlannedTier[]>();

  constructor() {}

  ngOnChanges() {
    if (this.tiers.length === 0) {
      this.addEmptyTier();
    }

    if (this.selectedTier) {
      this.selectedUUID = this.selectedTier.id;
    } else {
      // if (this.workoutType && this.tiers.length >= 3) {
      //   // if standard workout type, default to tier 3 selected first
      //   this.selectTier(this.tiers[2]);
      // } else {
      this.selectTier(this.tiers[0]);
      // }
    }

    this.tiers.forEach(tier => {
      tier.rows = tier.rows.sort(PlanDocumentUtils.sortTiers);
    });
  }

  dropped(event: CdkDragDrop<any[]>) {
    const tiers = cloneDeep<PlannedTier[]>(this.tiers);
    moveItemInArray(tiers, event.previousIndex, event.currentIndex);
    tiers.forEach((tier, index) => {
      tier.order = index + 1;
    });

    this.tiers = tiers;

    this.tiersUpdated.emit(tiers);
  }

  addEmptyTier() {
    this.addedTierFromLibrary.emit(this.tiers);
  }

  isSelected(id: string): boolean {
    return id === this.selectedUUID;
  }

  selectTier(tier: PlannedTier) {
    this.selectedUUID = tier.id;
    this.tierSelected.emit(tier);
  }
}
